import { render, staticRenderFns } from "./ViewPost.vue?vue&type=template&id=3d74bbac&scoped=true&"
import script from "./ViewPost.vue?vue&type=script&lang=js&"
export * from "./ViewPost.vue?vue&type=script&lang=js&"
import style0 from "./ViewPost.vue?vue&type=style&index=0&id=3d74bbac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d74bbac",
  null
  
)

export default component.exports